import { Link } from "react-router-dom";

const coachingCards = [
  { label: "Mindset", icon: "ri-mental-health-line", color: "from-teal-500 to-emerald-600" },
  { label: "Life", icon: "ri-heart-pulse-line", color: "from-rose-400 to-pink-600" },
  { label: "Career", icon: "ri-briefcase-4-line", color: "from-amber-400 to-orange-500" },
  { label: "Corporate", icon: "ri-building-4-line", color: "from-slate-500 to-slate-700" },
  { label: "Wellness", icon: "ri-leaf-line", color: "from-green-400 to-teal-600" },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/52eabb2be2de0c8680f22d664f6dc8df.jpg"
          alt="Mind Odyssey Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 pt-24 pb-16">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
          <span className="text-white/90 text-sm font-medium">Transform Your Mind. Transform Your Life.</span>
        </div>

        {/* Title */}
        <h1
          className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Your Journey to
          <br />
          <span className="text-teal-400">Limitless Growth</span>
          <br />
          Starts Here
        </h1>

        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Join thousands of adults unlocking their potential through world-class mindset, life, career, and corporate coaching programs.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link
            to="/register"
            className="px-8 py-4 bg-teal-500 hover:bg-teal-400 text-white font-semibold rounded-full transition-all text-base cursor-pointer whitespace-nowrap"
          >
            Start Your Journey
          </Link>
          <Link
            to="/programs"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 hover:bg-white/20 text-white font-semibold rounded-full transition-all text-base cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-play-circle-line text-teal-400" />
            Explore Programs
          </Link>
        </div>

        {/* Coaching Category Cards */}
        <div className="flex items-end justify-center gap-3 flex-wrap">
          {coachingCards.map((card, i) => (
            <div
              key={card.label}
              className={`bg-gradient-to-br ${card.color} rounded-2xl p-5 flex flex-col items-center gap-2 cursor-pointer hover:scale-105 transition-transform`}
              style={{
                transform: `rotate(${(i - 2) * 5}deg) translateY(${Math.abs(i - 2) * 8}px)`,
                width: "100px",
              }}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${card.icon} text-white text-2xl`} />
              </div>
              <span className="text-white text-xs font-semibold">{card.label}</span>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mt-16">
          {[
            { value: "12,000+", label: "Active Members" },
            { value: "200+", label: "Expert Coaches" },
            { value: "4.9★", label: "Average Rating" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </div>
              <div className="text-white/60 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
